import { alpha } from '@mui/material/styles';

import { isLightTheme } from '../../utils';

import type { OverWritable } from '../../@types/settings';

export const drawer: OverWritable = {
  MuiDrawer: {
    styleOverrides: {
      modal: ({ theme }) => {
        const isLight = isLightTheme(theme);

        return {
          '&[role="presentation"]': {
            '& .MuiDrawer-paperAnchorLeft': {
              boxShadow: `8px 24px 24px 12px ${alpha(
                theme.palette.grey[900],
                isLight ? 0.16 : 0.48
              )}`,
            },
            '& .MuiDrawer-paperAnchorRight': {
              boxShadow: `-8px 24px 24px 12px ${alpha(
                theme.palette.grey[900],
                isLight ? 0.16 : 0.48
              )}`,
            },
          },
        };
      },
    },
  },
};
